'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { DownloadSection } from './DownloadSection'
import { GitHubRelease } from '@/lib/github'

export function AllSoftwareUpgradeClient({
  hostd,
  renterd,
  walletd,
}: {
  hostd: { daemon: GitHubRelease | null; desktop: GitHubRelease | null }
  renterd: { daemon: GitHubRelease | null; desktop: GitHubRelease | null }
  walletd: { daemon: GitHubRelease | null; desktop: GitHubRelease | null }
}) {
  return (
    <Section bgClassName="bg-paper-1">
      {hostd.daemon && hostd.desktop && (
        <DownloadSection
          daemon="hostd"
          releaseDaemon={hostd.daemon}
          releaseDesktop={hostd.desktop}
          statusDesktop="beta"
        />
      )}
      {renterd.daemon && renterd.desktop && (
        <DownloadSection
          daemon="renterd"
          releaseDaemon={renterd.daemon}
          releaseDesktop={renterd.desktop}
        />
      )}
      {walletd.daemon && walletd.desktop && (
        <DownloadSection
          daemon="walletd"
          releaseDaemon={walletd.daemon}
          releaseDesktop={walletd.desktop}
        />
      )}
    </Section>
  )
}
